<template>
  <header>
    <div class="logo-container" @click="goToAbout">
      <img src="../assets/evoquant_logo.svg" alt="Logo" class="logo-image">
      <!-- 根据语言动态切换图片 -->
      <img 
        v-if="selectedLanguage === 'zh-CN'" 
        src="../assets/evoquant_cn.svg" 
        alt="Evoquant CN" 
        class="logo-text-image"
      >
      <img 
        v-else 
        src="../assets/evoquant_en.svg" 
        alt="Evoquant EN" 
        class="logo-text-image-en"
      >
    </div>
    <nav>
      <router-link to="/about" class="nav-button">{{ headerText.nav.about }}</router-link>
      <router-link to="/careers" class="nav-button">{{ headerText.nav.careers }}</router-link>
      <router-link to="/contact" class="nav-button">{{ headerText.nav.contact }}</router-link>
      <div class="language-toggle" @click="toggleLanguage">
        {{ selectedLanguage === 'en-US' ? 'CN' : 'EN' }}
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderView',
  props: {
    language: {
      type: String,
      default: 'zh-CN'
    }
  },
  data() {
    return {
      selectedLanguage: this.language,
      headerText: {
        logo: '',
        nav: {
          about: '',
          careers: '',
          contact: ''
        }
      }
    };
  },
  watch: {
    language: {
      immediate: true,
      handler(newLang) {
        this.selectedLanguage = newLang;
        this.loadText(newLang);
      }
    }
  },
  methods: {
    goToAbout() {
      this.$router.push('/');
    },
    toggleLanguage() {
      const newLang = this.selectedLanguage === 'zh-CN' ? 'en-US' : 'zh-CN';
      this.selectedLanguage = newLang;
      this.$emit('change-language', newLang);
    },
    async loadText(lang) {
      try {
        const response = await fetch(`/locales/${lang}.json`);
        const data = await response.json();
        this.headerText = data.header;
      } catch (error) {
        console.error('Failed to load language file:', error);
      }
    }
  },
  mounted() {
    this.loadText(this.selectedLanguage);
  }
};
</script>

<style scoped>
.logo-text-image {
  height: 22px; /* 根据需要调整高度 */
  margin-left: 10px; /* 与图标的间距 */
  margin-top: 10px; /* 与图标的间距 */
}

.logo-text-image-en {
  height: 20px; /* 根据需要调整高度 */
  margin-left: 10px; /* 与图标的间距 */
  margin-top: 10px; /* 与图标的间距 */
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px 30px;
  z-index: 1000;
  box-sizing: border-box;
  font-family: 'Orbitron', sans-serif;
  text-transform: uppercase;
  background-color: transparent;
}

.logo-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo-image {
  width: 60px; /* 设置图标的宽度 */
  height: 60px; /* 设置图标的高度 */
  margin-right: 10px; /* 图标和文本之间的间距 */
}

.logo-text {
  font-family: "思源宋体 Heavy", sans-serif;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 6px;
  text-transform: uppercase;
}

nav {
  display: flex;
  gap: 20px;
}

.nav-button {
  margin-top: 12px;
  display: inline-block;
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 540;
  text-decoration: none;
  color: white;
  letter-spacing: 1px;
  transition: color 0.3s ease, text-decoration 0.3s ease;
}

.nav-button:hover {
  color: #ccc;
  text-decoration: underline;
  text-underline-offset: 8px;
}

/* 语言切换按钮 */
.language-toggle {
  margin-top: 12px;
  font-size: 18px;
  color: white;
  cursor: pointer;
  font-weight: 540;
  padding: 10px 20px;
}

.language-toggle:hover {
  color: #ffcc00;
}
</style>
